var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.815,
    height: 21.076,
    viewBox: "0 0 17.815 21.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    width: 17.815,
    height: 21.076,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3589",
    "data-name": "Group 3589",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2882",
    "data-name": "Path 2882",
    d: "M17.814,10.51q0,3.974,0,7.948A2.581,2.581,0,0,1,15.786,21a3.167,3.167,0,0,1-.707.077q-6.165,0-12.33,0A2.628,2.628,0,0,1,0,18.336Q0,10.528,0,2.72A2.61,2.61,0,0,1,2.736,0q6.2,0,12.406,0a2.577,2.577,0,0,1,2.672,2.663q0,3.923,0,7.846m-16.1,0q0,3.911,0,7.823a.925.925,0,0,0,1.039,1.031c4.1,0,8.2-.007,12.307.009a1,1,0,0,0,1.058-1.05q-.023-7.81,0-15.62a1,1,0,0,0-1.056-1.053c-4.1.016-8.2.008-12.307.009A.928.928,0,0,0,1.71,2.715q0,3.9,0,7.8",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2883",
    "data-name": "Path 2883",
    d: "M115.105,84.177q-1.312,0-2.624,0a.863.863,0,0,1-.96-.83.878.878,0,0,1,.936-.869c1-.011,2,0,3.007,0q1.121,0,2.242,0a.944.944,0,0,1,.874.422.771.771,0,0,1,.031.843.8.8,0,0,1-.728.435c-.926,0-1.852,0-2.777,0",
    transform: "translate(-103.927 -76.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2884",
    "data-name": "Path 2884",
    d: "M115.4,143.129h-2.268a.964.964,0,0,1-.784-.3.788.788,0,0,1-.152-.877.819.819,0,0,1,.775-.527c.509-.009,1.019,0,1.529,0q1.656,0,3.312,0a.866.866,0,0,1,.889.8.842.842,0,0,1-.73.869,1.982,1.982,0,0,1-.354.029c-.739,0-1.478,0-2.217,0",
    transform: "translate(-104.489 -131.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2885",
    "data-name": "Path 2885",
    d: "M114.346,201.6c-.628,0-1.255,0-1.883,0a.871.871,0,0,1-.942-.828.9.9,0,0,1,.933-.877q1.908-.008,3.817,0a.86.86,0,0,1,.936.859.879.879,0,0,1-.952.847c-.636,0-1.272,0-1.908,0",
    transform: "translate(-103.928 -186.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2886",
    "data-name": "Path 2886",
    d: "M45.672,138.993a1.216,1.216,0,1,1,1.2-1.228,1.229,1.229,0,0,1-1.2,1.228",
    transform: "translate(-41.418 -127.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2887",
    "data-name": "Path 2887",
    d: "M45.632,197.071a1.224,1.224,0,0,1-1.225-1.2,1.219,1.219,0,0,1,2.437-.013,1.219,1.219,0,0,1-1.212,1.216",
    transform: "translate(-41.383 -181.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2888",
    "data-name": "Path 2888",
    d: "M45.634,80.3a1.225,1.225,0,0,1-1.226-1.2,1.219,1.219,0,0,1,2.437-.015A1.225,1.225,0,0,1,45.634,80.3",
    transform: "translate(-41.384 -72.572)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuReports);
export default __webpack_public_path__ + "static/media/icon_menu_reports.5b4f649c3bf74754ea44f8572726a31c.svg";
export { ForwardRef as ReactComponent };